import { Component } from "react";
import Layout from "../../component/layout";
import NextSeoModule from "../../component/next-seo";
 import Sapabaptemplate from "../../component/course/sap-abap";

export default class Sapabapinmumbai extends Component {
 
  render() {
 
    const title = "SAP ABAP"
    const url ="sap-abap"
    const url1 ="-training-in-mumbai"
    const location = "mumbai" 
    const location1="Training in Mumbai"
    
    return(
      <>
          <NextSeoModule
            title={`${title} ${location1} - learnsoft.org`}
            description={`Enroll in Top-notch SAP ABAP Training in ${location} and Acquire In-Demand Skills for a Rewarding Career in Software Development.`}
            url={`${location}/${url}${url1}`}
           img={`course/${url}.webp`}
            keyword={`${title} training in Chennai, ${title} certification in Chennai, Online ${title}  Training in Chennai, ${title} Online Training in Chennai, ${title} Syllabus, ${title} Placement Training in Chennai, ${title} course in Chennai, ${title} classes in Chennai, ${title} institute in Chennai, Best ${title} training institute in Chennai, ${title} training and certification in Chennai, Best ${title} training in Chennai, ${title} coaching in Chennai, ${title} training center in Chennai, ${title} training provider in Chennai`}
          />
        <Layout navbarBackgroundColor="#281E1E">
          <Sapabaptemplate url1={url1} title={title} url={url} relatedlocation={location} location={location} location1={location1} />
         </Layout>
      </>
    );
  }
}
